/* esm.sh - @tiptap/extension-text@3.25.0 */
import{Node as t}from"@tiptap/core";var r=t.create({name:"text",group:"inline",parseMarkdown:e=>({type:"text",text:e.text||""}),renderMarkdown:e=>e.text||""}),n=r;export{r as Text,n as default};
//# sourceMappingURL=extension-text.mjs.map